<template>
  <cargo-ag-grid
    :grid-options="gridOptions"
    :column-defs="columnDefs"
    :row-data="finalRowData"
    :show-side-bar="false"
    :class="{'checkbox-disabled':!isEdit}"
    @gridReady="params=>{gridApi=params.api}"
  />
</template>

<script>
import { SyncManager } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'

export default {
  name: 'SpecialRequestsGrid',
  props: {
    job: { type: Object, default: null },
    value: { type: String, required: true },
    isEdit: { type: Boolean, required: true },
    customerId: { type: Number, required: true },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      innerValue: this.value,
      rowData: []
    }
  },
  computed: {
    finalRowData() {
      return this.rowData.filter(p => p.lob === this.lob || p.lob === 'ALL' || !this.lob)
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.innerValue) {
        this.innerValue = newVal
        this.toDealSelectedState()
        if (this.gridApi) {
          this.gridApi.setRowData(this.finalRowData)
        }
      }
    },
    customerId(newVal) {
      this.syncManager.execute(async() => {
        this.toQuery()
      })
    }
  },
  created() {
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      onRowDataChanged: event => {
        const nodes = event.api.rowModel.rowsToDisplay
        for (const item of nodes) {
          if (item.data.selected) {
            item.setSelected(true)
          }
        }
      },
      onSelectionChanged: () => {
        this.onSelectionChanged()
      },
      context: {
        componentParent: this
      }
    }
    this.columnDefs = [
      {
        headerName: this.$t('SeaExport.CustomerSpecialRequirements'),
        field: 'request',
        suppressMenu: true,
        width: 230
      }, {
        width: 40,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false
      }
    ]
    this.gridApi = null
    this.syncManager = new SyncManager()
    // CARGO-11874 海出详情加载优化【这里不需要查询】
    // this.syncManager.execute(async() => {
    //   this.toQuery()
    // })
  },
  methods: {
    async toQuery() {
      this.rowData = []
      if (!this.customerId) {
        return
      }
      const company = await Company.getCompanyById(this.customerId)
      if (!company) {
        return
      }
      const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
      if (!customer) {
        return
      }
      this.rowData = await new Customer(customer).getSpecialRequests()
      this.toDealSelectedState()
    },
    // 处理选中状态
    toDealSelectedState() {
      let selectedVals = []
      if (this.innerValue) {
        selectedVals = this.innerValue.split(',')
        selectedVals = selectedVals.map(item => item.trim())
      }
      for (const item of this.rowData) {
        if (item.request && selectedVals.includes(item.request.trim())) {
          item.selected = true
        } else {
          item.selected = false
        }
      }
    },
    onSelectionChanged() {
      for (const item of this.rowData) {
        item.selected = false
      }
      const rows = this.gridApi.getSelectedRows()
      let text = ''
      for (const item of rows) {
        item.selected = true
        if (text) {
          text += ','
        }
        text += item.request
      }
      this.innerValue = text
      this.$emit('input', this.innerValue)
      if (this.job) {
        // 记录选中的uuid用于打印
        this.job.requestSelectedKeys = Array.from(rows, p => p.uuid)
      }
    },
    getRequestSelectedKeys() {
      const rows = this.gridApi.getSelectedRows()
      return Array.from(rows, p => p.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-disabled ::v-deep {
  .ag-header-select-all {
    pointer-events: none;
  }
  .ag-selection-checkbox {
    pointer-events: none;
  }
}
</style>
